import { Component } from "react"

function pubsub(WrappedComponent) {
  const PubSubComponent = class extends Component {
    listeners = []

    publish = (...args) => {
      this.listeners.forEach(listener => listener(...args))
      this.lastParams = [...args]
    }

    subscribe = listener => {
      this.listeners.push(listener)
      if (this.lastParams) {
        listener(...this.lastParams)
      }
    }

    unsubscribe = listener => {
      this.listeners = this.listeners.filter(l => l !== listener)
    }

    render() {
      return <WrappedComponent subscribe={this.subscribe} unsubscribe={this.unsubscribe} publish={this.publish} {...this.props} />
    }
  }
  PubSubComponent.displayName = `pubsub(${WrappedComponent.displayName || WrappedComponent.name})`
  return PubSubComponent
}

export default pubsub
